export default __webpack_public_path__ + "static/media/21.5a7c2ef3.png";